module.exports = __webpack_public_path__ + "static/media/resimator_logo.ccfbf433.png";